import { guideItems, voices } from "../data";

export default function GuideSection() {
  return (
    <section id="guide" className="scroll-mt-24 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          {/* guide grid */}
          <div className="lg:col-span-7">
            <p className="text-primary-600 font-semibold tracking-wide text-sm">GUIDE · 伦理与自保指南</p>
            <h2 className="mt-2 font-heading text-3xl md:text-4xl font-extrabold text-foreground-950">
              拍与被拍，都该知道的几条底线
            </h2>
            <p className="mt-3 text-foreground-600 leading-7 max-w-2xl">
              我们并不反对记录街头真实，只反对以冒犯与消费他人为代价的流量。以下原则适用于创作者，也帮助被拍者维护自己。
            </p>

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
              {guideItems.map((g) => (
                <div
                  key={g.title}
                  className="p-5 rounded-2xl border border-background-200 bg-background-100 hover:border-accent-300 transition group"
                >
                  <div className="flex items-center gap-3">
                    <span className="w-10 h-10 shrink-0 rounded-full bg-accent-100 text-accent-700 flex items-center justify-center text-lg group-hover:bg-accent-500 group-hover:text-background-50 transition">
                      <i className={g.icon}></i>
                    </span>
                    <h3 className="font-heading text-base font-bold text-foreground-950">{g.title}</h3>
                  </div>
                  <p className="mt-3 text-sm leading-6 text-foreground-600">{g.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* voices side */}
          <aside className="lg:col-span-5" aria-label="多方视角">
            <div className="p-6 md:p-7 rounded-3xl bg-foreground-950 text-background-50 overflow-hidden relative">
              <div className="pointer-events-none absolute -top-10 -right-10 w-44 h-44 rounded-full bg-primary-500/40 blur-3xl"></div>
              <div className="relative">
                <p className="text-accent-200 font-semibold tracking-wide text-sm">VOICES · 各方怎么说</p>
                <h3 className="mt-2 font-heading text-2xl font-bold">把争议放在同一张桌上</h3>
                <div className="mt-6 space-y-5">
                  {voices.map((v) => (
                    <blockquote key={v.name} className="rounded-2xl bg-background-50/10 border border-background-50/10 p-4">
                      <p className="text-[15px] leading-7 text-background-100">"{v.quote}"</p>
                      <footer className="mt-3 flex items-center gap-2 text-sm">
                        <span className="w-1.5 h-1.5 rounded-full bg-accent-400"></span>
                        <span className="text-accent-200 font-medium">{v.role}</span>
                        <span className="text-background-200">· {v.name}</span>
                      </footer>
                    </blockquote>
                  ))}
                </div>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}